// extracted by mini-css-extract-plugin
export var office = "open-position-module--office--6f050";
export var wrapper = "open-position-module--wrapper--4b2f7";